import * as types from "./mutation-types";

export const toggleSidebar = ({ commit }, opened) => {
  commit(types.TOGGLE_SIDEBAR, opened);
};

export const toggleDevice = ({ commit }, device) =>
  commit(types.TOGGLE_DEVICE, device);

export const permission = ({ commit }, permissions) =>
  commit(types.PERMISSION, permissions);

export const profile = ({ commit }, profile) => commit(types.PROFILE, profile);

export const noti_report = ({ commit }, payload) => {
  commit(types.NOTI_REPORT, payload);
};

export const expandMenu = ({ commit }, menuItem) => {
  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(types.EXPAND_MENU, menuItem);
  }
};

export const switchEffect = ({ commit }, effectItem) => {
  if (effectItem) {
    commit(types.SWITCH_EFFECT, effectItem);
  }
};

export const tag = ({ commit }, payload) => commit(types.TAG, payload);

export const loadingReport = ({ commit }, payload) =>
  commit(types.LOADING_REPORT, payload);

export const timezone = ({ commit }, timezone) =>
  commit(types.TIMEZONE, timezone);

export const currency = ({ commit }, currency) =>
  commit(types.CURRENCY, currency);

export const resetMenu = ({ commit }, resetMenu) =>
  commit(types.RESET_MENU, resetMenu);

export const setting = ({ commit }, setting) => commit(types.SETTING, setting);
